

export const frontMatter = {
	sidebar_position: 8,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/syntax.html'
};
export const contentTitle = 'Сінтаксіс';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-be-docusaurus-plugin-content-docs-current-learn-grammar-syntax-md-77c.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    header: "header",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "сінтаксіс",
        children: "Сінтаксіс"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Парадак слоў у асноўным свабодны, але пераважны (і стылістычна найбольш нейтральны) парадак слоў суб'ект - дзеяслоў - аб'ект (SVO). Гэта не з'яўляецца абавязковым, але звярніце ўвагу, што размяшчэнне аб'екта перад суб'ектам не дапаможа зразумець сэнс. Гэта не той выпадак са сказамі, дзе асабовы займеннік або займеннік ", _jsx(TransliteratorElement, {
        children: "kto"
      }), " з'яўляюцца дзейнікам або дапаўненнем, таму што асабовыя займеннікі і ", _jsx(TransliteratorElement, {
        children: "kto"
      }), " маюць свае формы вінавальнага склону, таму сэнс заўсёды ясны."]
    }), "\n", _jsx(_components.p, {
      children: "Мадыфікатары звычайна стаяць перад назоўнікам. Гэта таксама не з'яўляецца абавязковым, але гэта самы нейтральны і найбольш зразумелы спосаб пабудовы сказа."
    }), "\n", _jsx(_components.p, {
      children: "Ёсць два тыпы пытанняў:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Так-не пытанні можна задаваць трыма рознымі спосабамі:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["альбо адрозніваецца ад звычайнага апавядальнага сказа толькі інтанацыяй:", "\n", _jsxs(_components.ul, {
              children: ["\n", _jsxs(_components.li, {
                children: [_jsx(TransliteratorElement, {
                  children: "Otec kupil knigu?"
                }), " «Ці купіў бацька кнігу?»"]
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["або перад гэтым сказам стаіць часціца ", _jsx(TransliteratorElement, {
              children: "či"
            }), ":", "\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: _jsx(TransliteratorElement, {
                  children: "Či otec kupil knigu?"
                })
              }), "\n"]
            }), "\n"]
          }), "\n", _jsxs(_components.li, {
            children: ["або ён пазначаны пытальнай часціцай ", _jsx(TransliteratorElement, {
              children: "li"
            }), ", размешчанай адразу пасля фокусу пытання, звычайна дзеяслова:", "\n", _jsxs(_components.ul, {
              children: ["\n", _jsx(_components.li, {
                children: _jsx(TransliteratorElement, {
                  children: "Kupil li otec knigu?"
                })
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Іншыя пытанні пачынаюцца з пытальнага займенніка або прыслоўя, якія ставяцца ў пачатку сказа:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Koju knigu kupil otec?"
            }), " «Якую кнігу купіў бацька?»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Kde otec kupil tu knigu?"
            }), " «Дзе бацька купіў гэтую кнігу?»\nУ сказах гэтага тыпу значэнне звычайна становіцца зразумелым у выкарыстаным выпадку:"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Koja žena ljubi togo muža?"
            }), " «Якая жанчына любіць гэтага мужчыну?» (жанчына = суб'ект, мужчына = аб'ект)"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Koju ženu ljubi toj muž?"
            }), " «Якую жанчыну любіць гэты мужчына?» (мужчына = суб'ект, жанчына = аб'ект)"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["Пры неабходнасці можна выкарыстоўваць заўсёды зразумелыя пасіўныя сказы:", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Koja žena jest ljubjena od togo muža?"
            }), " «Якую жанчыну любіць гэты мужчына?»"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Канчатковыя прапановы перакладаюцца з дапамогай ", _jsx(TransliteratorElement, {
        children: "že"
      }), " або ", _jsx(TransliteratorElement, {
        children: "da"
      }), ", за якімі ідзе ўмоўны лад:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Turisti posětet Niderlandiju, že by fotografovali tulipany."
        }), " «Турысты наведваюць Нідэрланды, каб сфатаграфаваць цюльпаны»."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Turisti posětili Niderlandiju, že by fotografovali tulipany."
        }), " «Турысты наведалі Нідэрланды, каб сфатаграфаваць цюльпаны»."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Ona prinosi jabloka, da by děti byli zdrave."
        }), " «Яблыкі нясе, каб дзеткі здаровыя былі»."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "Ona prinosila jabloka, da by děti byli zdrave."
        }), " «Яблычак прынесла, каб дзеткі здаровыя былі»."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Пасіўны стан можна выкарыстоўваць, але калі так, то рабіць гэта трэба асцярожна. Сказ накшталт: ", _jsx(TransliteratorElement, {
        children: "Pica je dělana"
      }), " або ", _jsx(TransliteratorElement, {
        children: "Pica je dělajema"
      }), " «Піца рыхтуецца» граматычна цалкам правільны. Але ўсё ж лепш гэтага пазбегнуць, бо такая канструкцыя гучыць нязграбна для тых славян, якія не прывыклі часта ўжываць дзеяслоў «быць», асабліва ў цяперашнім часе. Акрамя таго, калі для часткі славянамоўных гэта цалкам натуральна, для іншых дзеепрыметнік прошлага часу ўвогуле не можа ўжывацца для канструкцыі цяперашняга часу. Таму, калі дзейнік вядомы, лепш выкарыстоўваць звычайны дзейны сказ. А калі дзейнік невядомы, як у выпадку з нашай піцай, можна ўжыць форму трэцяй асобы множнага ліку без дзейніка: ", _jsx(TransliteratorElement, {
        children: "Dělajut picu"
      }), " „Яны робяць піцу, адзін робіць піцу, піца робіцца”. Яшчэ больш распаўсюджанай з'яўляецца зваротная канструкцыя: ", _jsx(TransliteratorElement, {
        children: "Pica dělaje se"
      }), ", што літаральна азначае «Піца робіцца сама» і павінна перакладацца як «Піцу робяць, піцу робяць»."]
    }), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

